import React, { useEffect, useState } from 'react';
import { getHFModels, HFResult } from '../../utils/api';
import { formatCompact, formatInt } from '../../utils/format';
import { DataBadge } from '../DataBadge';
import { SourceRef } from '../SourceRef';
export function HFLiveTable() {
  const [result, setResult] = useState<HFResult | null>(null);
  useEffect(() => {
    let alive = true;
    getHFModels().then(r => alive && setResult(r));
    return () => {
      alive = false;
    };
  }, []);
  const max = result ? Math.max(...result.models.map(m => m.downloads), 1) : 1;
  return <div data-id="element-374" data-mp="1iffo1slhcp9h">
      <div className="flex flex-wrap items-center justify-between gap-3" data-id="element-375" data-mp="1ifpchbqvmod2">
        <h2 className="font-serif text-2xl text-ink md:text-3xl" data-id="element-376" data-mp="1ihse6t1e65xm">
          Most-downloaded on Hugging Face
          <SourceRef id="hfApi" data-id="element-377" data-mp="2tumhvw7dbq6l" />
        </h2>
        <DataBadge mode={result ? result.mode : 'loading'} source={result?.mode === 'live' ? 'live from Hugging Face' : 'Hugging Face'} asOf={result?.asOf} data-id="element-378" data-mp="2ttt62gtjyahl" />
      </div>
      <p className="mt-2 max-w-2xl text-[14px] text-muted" data-id="element-379" data-mp="3hae09nsyw7dz">
        What actually runs: downloads are dominated by small embedding and encoder models, not frontier chat models.
      </p>
      <ol className="mt-6 divide-y divide-line border-y border-line" data-id="element-380" data-mp="37bojjyct4szb">
        {(result?.models ?? []).map((m, i) => <li key={m.id} className="grid grid-cols-[2.5rem_minmax(0,1fr)_auto] items-center gap-x-4 py-2.5 md:grid-cols-[2.5rem_minmax(0,22rem)_minmax(0,1fr)_7rem_5rem]" data-id="element-381" data-mp="32dd6ler7u2cv" data-mpi={i}>
            <span className="font-mono text-[12px] text-muted" data-id="element-382" data-mp="2tk9wngfs47mz">{i + 1}</span>
            <a href={`https://huggingface.co/${m.id}`} target="_blank" rel="noopener noreferrer" className="truncate text-[13.5px] text-ink hover:text-machine" data-id="element-383" data-mp="2ti6xa5sql25l">
              {m.id}
            </a>
            <div className="hidden h-1.5 rounded-full bg-raised md:block" aria-hidden="true" data-id="element-384" data-mp="2jjzi9si0cu68">
              <div className="h-full rounded-full bg-machine/70" style={{
            width: `${m.downloads / max * 100}%`
          }} data-id="element-385" data-mp="2em7p6v5mn20g" />
            </div>
            <span className="text-right font-mono text-[12.5px] tabular text-ink" title={`${formatInt(m.downloads)} downloads`} data-id="element-386" data-mp="200k6lef2o5jp">
              {formatCompact(m.downloads)}
            </span>
            <span className="hidden text-right font-mono text-[11.5px] text-muted md:block" data-id="element-387" data-mp="1qzm10rozjpz0">♥ {formatCompact(m.likes)}</span>
          </li>)}
        {!result && <li className="py-10 text-center font-mono text-xs text-muted" role="status" data-id="element-388" data-mp="1vyyuhvad3vak">
            Fetching live layer…
          </li>}
      </ol>
      <p className="mt-2 font-mono text-[11px] text-faint" data-id="element-389" data-mp="2nq4ri2usdcvm">Downloads over the trailing 30 days as reported by the Hub API.</p>
    </div>;
}